import React, { useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from '@mui/material';
import {
  capitalizeWords,
  formatDateAndTime,
  lockWidth,
} from '../../../utils/helper';
import { INotification } from '../../../utils/entities/interface';
import { useNavigate } from 'react-router-dom';
import { SkeletonRows } from '../../skeletons/list';
import { ListTable } from '../../molecules/ListTable';

export const PromotionList = ({
  notifications,
  onUpdate,
  isLoading,
  headerCells,
}: {
  notifications: INotification[];
  onUpdate: () => void;
  isLoading: boolean;
  headerCells: [string, number][];
}) => {
  return (
    <>
      <ListTable
        headerCells={headerCells}
        rows={notifications}
        isLoading={isLoading}
        renderCell={(notification: INotification, colIndex: number) => {
          switch (colIndex) {
            case 0:
              return capitalizeWords(notification.title) || 'N/A';
            case 1:
              return capitalizeWords(notification.body);
            case 2:
              return formatDateAndTime(notification.createdAt);
            default:
              return null;
          }
        }}
      />
    </>
  );
};
